import { Box, Icon, IconButton, useTheme } from "@mui/material";
import { useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { PhotoDto } from "../../../api/psc";
import { DialogHeader } from "../../../components/exports";
import {
    DefaultDarkProjectImagePath,
    DefaultProjectImagePath,
} from "../../../constants/ProjectConstants";

export default function ProjectMobileImageGallery(props: {
    photos: PhotoDto[];
    toggle: () => void;
}) {
    const theme = useTheme();
    const [index, setIndex] = useState<number>(0);

    const projectPlaceHolder =
        theme.palette.mode === "light"
            ? DefaultProjectImagePath
            : DefaultDarkProjectImagePath;

    const photos = props.photos;
    const hasPhoto = photos.length > 0;

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                zIndex: 99,
                bgcolor: "background.paper",
                overflowY: "scroll",
                overflowX: "hidden",
            }}
        >
            <DialogHeader
                title="گالری تصاویر پروژه"
                action={
                    <IconButton onClick={props.toggle}>
                        <Icon>close</Icon>
                    </IconButton>
                }
            />

            <TransformWrapper
                initialScale={500 / (window.innerWidth / (4 / 3))}
                centerOnInit={true}
            >
                <TransformComponent wrapperStyle={{ minHeight: "500px" }}>
                    <img
                        src={
                            hasPhoto
                                ? photos[index].imageUrl
                                : projectPlaceHolder
                        }
                        style={{ width: "100% " }}
                    />
                </TransformComponent>
            </TransformWrapper>

            <Box
                sx={{
                    overflowX: "scroll",
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "row",
                    gap: 1,
                    m: 1,
                    justifyContent: "space-between",
                }}
            >
                {photos.map((p, i) => {
                    return (
                        <Box
                            onClick={() => setIndex(i)}
                            key={p.imageId}
                            component="img"
                            sx={{
                                cursor: "pointer",
                                display: "block",
                                width: "67px",
                                height: "50px",
                                borderRadius: "4px",
                                opacity: i === index ? 1 : 0.75,
                            }}
                            src={p.imageUrl}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
